import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Button from "../../../../component/Button/Button";

const CvUpload = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getCvUpload");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        const list = response.data.data.reverse();
        setList(list);

        setLoading(false);
      })
      .catch((error) => {
        // alert("Something Went Wrong");
      });
  }, []);
  return (
    <>
      <MaterialTable
        title="Drop Your Cv"
        columns={[
          {
            title: "Date",
            field: "date",
          },
          {
            title: "Time",
            field: "time",
          },

          {
            field: "url",
            title: "Resume Link",
            render: (rowData) => (
              <Button
                title=" View Resume"
                onClick={() => {
                  let liveUrl = "https://api.laxmihos.com/api/";
                  let testUrl = "https://api.laxmihos.com/api/";
                  window.open(
                    liveUrl + rowData.resumeLink,
                    "_blank" // <- This is what makes it open in a new window.
                  );
                }}
              ></Button>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
};

export default CvUpload;
